// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wUzZ","signatureBlock":"Footer_signatureBlock__1gYOg","signature":"Footer_signature__SAGa1"};